import { render } from "./DevicePresencePanel.vue?vue&type=template&id=512f7c60"
import script from "./DevicePresencePanel.vue?vue&type=script&lang=js"
export * from "./DevicePresencePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__